import { fetchInsurancePackages } from "@src/services/insurance-package.service";

export interface EnsureSelfPayPackageLookupParams {
  selectPlan: string;
  packageLookupCompleted: boolean;
  userUuid?: string;
  contextId?: string | number;
  stateCode?: string;
}

/**
 * Ensures the insurance-package lookup has been completed before navigating
 * to provider search.  Only relevant for `self_pay` users — insurance users
 * already trigger the lookup when they enter a ZIP and select a plan.
 *
 * Returns `true` when the lookup is either unnecessary or succeeded,
 * `false` when it failed (caller should abort navigation).
 */
export async function ensureSelfPayPackageLookup(
  params: EnsureSelfPayPackageLookupParams,
): Promise<boolean> {
  const { selectPlan, packageLookupCompleted, userUuid, contextId, stateCode } = params;

  if (selectPlan !== "self_pay" || packageLookupCompleted) {
    return true;
  }

  if (!userUuid || contextId == null || !stateCode) {
    return false;
  }

  const result = await fetchInsurancePackages(userUuid, String(contextId), stateCode, true);

  if (result?.error) {
    return false;
  }

  return true;
}
